<template>
  <div class="householdequipment">
    <div class="header">
      <div class="title">多种智能家居硬件设备</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import householdequipment1 from "../../../../assets/programme/householdequipment1.png";
import householdequipment2 from "../../../../assets/programme/householdequipment2.png";
import householdequipment3 from "../../../../assets/programme/householdequipment3.png";
import householdequipment4 from "../../../../assets/programme/householdequipment4.png";
import householdequipment5 from "../../../../assets/programme/householdequipment5.png";
import householdequipment6 from "../../../../assets/programme/householdequipment6.png";

export default {
  setup() {
    return reactive({
      list: [
        {
          id: 1,
          title: "智能门锁",
          logo: householdequipment1,
        },
        {
          id: 2,
          title: "智能家电",
          logo: householdequipment2,
        },
        {
          id: 3,
          title: "智能照明",
          logo: householdequipment3,
        },
        {
          id: 4,
          title: "智能窗控",
          logo: householdequipment4,
        },
        {
          id: 5,
          title: "智能暖通",
          logo: householdequipment5,
        },
        {
          id: 6,
          title: "智能监控",
          logo: householdequipment6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.householdequipment {
  width: 92vw;
  margin: 24px auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.body .list .item {
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
}
.body .list .item img {
  width: 162px;
}
.body .list .item div {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  color: #ffffff;
  background: rgba(255, 255, 255, 0.2);
  padding: 16px 0;
  backdrop-filter: blur(20px);
}
</style>
